import qs from 'qs';

const LOCAL_STORAGE_KEY = 'mindbodyLaunchUrl';

/**
 * Capture the full launch URL at app boot — call once in index.tsx BEFORE React mounts,
 * while it's still the utility-button URL (the SDK redirect strips the query before any
 * page renders, and a later hard reload re-reads it).
 *
 * Gated on the host-supplied `authToken` so it acts ONLY on a fresh launch; the post-redirect
 * reload has no authToken, so the guard keeps the captured launch URL instead of overwriting
 * it with the stripped one.
 */
export const captureLaunchUrl = (): void => {
  const routeParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  if (!routeParams.authToken) {
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_KEY, window.location.href);
};

/** The utility-button launch URL captured at boot, or null if none was stored. */
export const getLaunchUrl = (): string | null => localStorage.getItem(LOCAL_STORAGE_KEY);
